import {downloadFile} from '@domain/file-download'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'
import {MateriaInstallationReportRequest} from '@refra/modules/refra-flexible-report/types'

const EXPORT_FILE_NAME = 'installations-report.xlsx'

export const useExportReport = () => {
  const {t} = useTranslation()

  const {isPending, mutateAsync} = useMutation({
    mutationFn: (payload: MateriaInstallationReportRequest) => mutations.generateReportExcel(payload),
    onSuccess: (blob) => {
      downloadFile(blob, EXPORT_FILE_NAME)
    },
    onError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useExportReport')
        .extras({errorDetails})
        .error('Error occurred while exporting report')

      spawnErrorToast(t('error.exportReport'))
    }
  })

  return {isExporting: isPending, exportReport: mutateAsync}
}
